module.exports = __webpack_public_path__ + "img/apple-pay-logo.e4ab429c.svg";